// @ts-nocheck
// Ensure dataLayer exists (prevents runtime errors if GTM loads later).
window.dataLayer = window.dataLayer || [];
var dataLayer = window.dataLayer;

// Push form events only after the submit has completed.
// For full-page form submits (login/signup), we persist a flag in sessionStorage,
// then push on the next page load.
(function () {
  const STORAGE_KEY = 'pendingDataLayerEvent';

  function setPendingEvent(eventName, extra) {
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ eventName: eventName, extra: extra || {} })
      );
    } catch (e) {
      // Ignore storage failures (private mode / disabled storage / etc).
    }
  }

  function flushPendingEvent() {
    let raw = null;
    try {
      raw = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return;
    }

    if (!raw) return;

    try {
      const parsed = JSON.parse(raw);
      if (parsed && parsed.eventName) {
        window.dataLayer.push({
          event: parsed.eventName,
          ...(parsed.extra || {}),
        });
      }
    } catch (e) {
      // If JSON is corrupted, just drop it.
    } finally {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
    }
  }

  document.addEventListener('DOMContentLoaded', flushPendingEvent);

  /**** FORM LOGIN ***/
  const loginForm = document.querySelector('#customer_login');
  if (loginForm) {
    loginForm.addEventListener('submit', function () {
      setPendingEvent('login');
    });
  }

  /**** FORM SIGNUP ***/
  const signupForm = document.querySelector('#create_customer');
  if (signupForm) {
    signupForm.addEventListener('submit', function () {
      setPendingEvent('signup');
    });
  }

  /**** FORM NEWSLETTER ***/
  const newsletterForm = document.querySelector('#sib-form');
  if (newsletterForm && newsletterForm.length) {
    newsletterForm.on('submit', function () {
      setPendingEvent('newsletter');
    });
  }
})();


/**** MENU ***/
let navLinks = document.querySelectorAll("nav a, nav span[href], .menu-drawer__menu-item");
if (navLinks) {
    navLinks.forEach(link => {
        link.addEventListener('click', function () {
            dataLayer.push({        
              "event": "click_menu", 
              "categoria_menu": link.innerText,
            });
        })
    });
}


/*** PHONE ***/
let trackPhone = document.querySelectorAll('a[href^="tel:"]');
if (trackPhone) {
    trackPhone.forEach(phone => {
        phone.addEventListener('click', function () {
            dataLayer.push({
                "event": "click_phone",
            });
        })
    });
}



/**** MAIL ***/
let trackEmail = document.querySelectorAll('a[href^="mailto:"]');
if (trackEmail) {
    trackEmail.forEach(email => {
        email.addEventListener('click', function () {
            dataLayer.push({
                "event": "click_mail",
            });
        })
    });
}


/**** SOCIAL ****/
let socials = document.querySelectorAll(".list-social__link");
if (socials) {
    socials.forEach(social => {
        social.addEventListener('click', function () {
            dataLayer.push({
                "event": "click_social",
                "nome_evento": social.dataset.social,
            });
        })
    });
}



/*** BLOG ***/
let trackBlogPosts = document.querySelectorAll(".blog-post-card");
if (trackBlogPosts) {
    trackBlogPosts.forEach(blogPost => {
        blogPost.addEventListener('click', function () {
            dataLayer.push({
                "event": "click_articolo_blog",
                "articolo_blog": blogPost.dataset.nome,
            });
        })
    });
}

